module.exports = __webpack_public_path__ + "img/journal-back.f79bae2f.svg";